import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubbleSparkle"><Path d="M3.5 3.5L20.5 3.50002V18.5H15.0155L11.9979 21L9.0155 18.5L3.5 18.5V3.5Z" stroke="currentColor"/><Path d="M12.399 7.25H11.599L10.599 9.85L7.99902 10.85V11.65L10.599 12.65L11.599 15.25H12.399L13.399 12.65L15.999 11.65V10.85L13.399 9.85L12.399 7.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleSparkle;
